import React from 'react';
import { Button } from './ui/button';
import { Card, CardHeader, CardContent, CardFooter } from './ui/card';
import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PricingCard({ plan }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleClick = () => {
    if (!user) {
      navigate('/register');
    } else {
      navigate('/submit-query', { state: { planType: plan.id } });
    }
  };

  return (
    <Card 
      className={`relative transition-all duration-300 hover:shadow-xl ${
        plan.highlighted 
          ? 'border-2 border-[#0078D4] shadow-lg scale-105' 
          : 'border border-gray-200'
      }`}
    >
      {plan.highlighted && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="bg-[#0078D4] text-white px-4 py-1 rounded-full text-sm font-semibold">
            Most Popular
          </span>
        </div>
      )}
      
      <CardHeader className="text-center pb-8 pt-8">
        <h3 className="text-2xl font-bold text-[#003366] mb-2">{plan.name}</h3>
        <div className="mb-4">
          <span className="text-5xl font-bold text-[#0078D4]">
            ${plan.price}
          </span>
          {plan.price > 0 && <span className="text-gray-600 ml-2">per query</span>}
        </div>
        <p className="text-gray-600">{plan.description}</p>
        <div className="mt-4 inline-block bg-green-50 text-green-700 px-4 py-2 rounded-full text-sm font-semibold">
          {plan.sla} Response SLA
        </div>
      </CardHeader>

      <CardContent className="pb-8">
        <ul className="space-y-3">
          {plan.features.map((feature, index) => (
            <li key={index} className="flex items-start space-x-3">
              <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
              <span className="text-gray-700">{feature}</span>
            </li>
          ))}
        </ul>
      </CardContent>

      <CardFooter>
        <Button 
          onClick={handleClick}
          className={`w-full h-12 text-lg font-semibold ${
            plan.highlighted
              ? 'bg-[#0078D4] hover:bg-[#005a9e]'
              : 'bg-[#003366] hover:bg-[#002244]'
          }`}
        >
          {plan.buttonText}
        </Button>
      </CardFooter>
    </Card>
  );
}
